import { useQuery } from '@tanstack/react-query';
import type { LottieComponentProps } from 'lottie-react';
import Lottie from 'lottie-react';
import { memo, useMemo } from 'react';

import { getLibraryContentQuery } from '../queries/common';

import { omit } from '@utilities/collection-utils';

const LottieAnimation = (props: Partial<LottieComponentProps> & { animationPath?: string }) => {
  const { animationPath } = props;
  const { data: animationData } = useQuery({
    ...getLibraryContentQuery(animationPath),
    enabled: !!animationPath,
  });

  const lottieProps = useMemo(
    () => ({
      loop: false,
      animationData,
      ...(omit(props, 'animationPath') as LottieComponentProps),
    }),
    [animationData, props],
  );

  if (!lottieProps.animationData) return null;

  return <Lottie {...lottieProps} />;
};

export default memo(LottieAnimation);
